import {
  Id,
  Identifiable,
  Resource,
  ResourceTypes,
  Role,
  Tag,
} from "@planzone/dto";
import { Filter as F } from "@planzone/dto";

type Filter = F & {
  resourceTypes: ResourceTypes[];
  roles: Identifiable<Role>[];
  areSortedByGroups: boolean;
  inactiveOnly: boolean;
};

enum SortOption {
  Default = "planzoneMembersPage.sorters.default",
  NAME = "planzoneMembersPage.sorters.name",
  Role = "planzoneMembersPage.sorters.role",
  CreationDate = "planzoneMembersPage.sorters.creationDate",
}

interface Props {}

export type { Props, Filter };

export { SortOption };
